"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddEvaluatorWrapper = exports.StyledForm = exports.titleStyles = exports.ScrollableTableContainer = void 0;
const styles_1 = require("@mui/material/styles");
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
const formik_1 = require("formik");
exports.ScrollableTableContainer = (0, styles_1.styled)(TableContainer_1.default)({
    maxHeight: "calc(100vh - 335px)",
    overflowY: "auto",
});
exports.titleStyles = {
    marginBottom: "12px",
};
exports.StyledForm = (0, styles_1.styled)(formik_1.Form)({
    "&:not(:last-of-type)": {
        marginBottom: "60px"
    }
});
exports.AddEvaluatorWrapper = (0, styles_1.styled)("div")({
    display: "flex",
    justifyContent: "center",
    margin: "20px 0"
});
